import { Recibo, TipoPagoRecibo } from '@/types/recibo';

export type ReciboReportTab = 'inquilinos' | 'propietarios';

export const parseReciboReportTab = (value: string | null): ReciboReportTab =>
  value === 'propietarios' ? 'propietarios' : 'inquilinos';

export const reciboReportTabToType = (tab: ReciboReportTab): TipoPagoRecibo =>
  tab === 'propietarios' ? TipoPagoRecibo.PROPIETARIO : TipoPagoRecibo.INQUILINO;

export type ReciboListResult = {
  items: Recibo[];
  total: number;
  page: number;
  totalPages: number;
};

export const emptyReciboListResult: ReciboListResult = {
  items: [],
  total: 0,
  page: 1,
  totalPages: 1,
};

export const normalizeReciboListResult = (
  response: any,
  fallbackPage: number,
  pageSize: number,
): ReciboListResult => {
  const payload = response?.success && response?.data ? response.data : response;
  const items = Array.isArray(payload)
    ? payload
    : Array.isArray(payload?.items)
      ? payload.items
      : Array.isArray(payload?.data)
        ? payload.data
        : [];
  const total = Number(payload?.total ?? items.length);

  return {
    items,
    total,
    page: Number(payload?.page ?? fallbackPage),
    totalPages: Number(payload?.totalPages ?? payload?.pages ?? Math.max(1, Math.ceil(total / pageSize))),
  };
};
